// **api server (production)
export const API_HOST = 'api-kpi.renessans-edu.uz';
export const WS_HOST = 'api-kpi.renessans-edu.uz';
export const API_URL = `https://${API_HOST}`;
export const IMG_URL = `https://${API_HOST}/media/`;
export const FILE_URL = `https://${API_HOST}/`;

// **api local (dynamic by current host) - only for same machine access
// export const API_HOST = `${window.location.hostname}:8000`;
// export const WS_HOST = `${window.location.hostname}:8000`;
// export const API_URL = `http://${API_HOST}`;
// export const IMG_URL = `http://${API_HOST}/media/`;
// export const FILE_URL = `http://${API_HOST}/`;
